import { Controller } from "@hotwired/stimulus"

// 予約設定の入力欄は、事前予約の有無・開催形式・参加人数の選択によって必須かどうかが変わる。
// 使われない欄を出したままにすると、どこを埋めれば保存できるのかが画面から読み取れないため、
// 事前予約が「有り」のときだけイベント予約設定の枠を表示し、その中でも入力が必要な行だけを表示する。
//
// 隠した枠・行の入力欄は disabled にする。隠しただけだと、残っている不正な値（定員の上限超えなど）を
// ブラウザが送信時に検査して、画面に出ていない欄で黙って送信を止めてしまうため。
// disabled の欄は検査の対象外になり、送信もされない。
export default class extends Controller {
  static targets = [
    "reservationRequired",
    "reservationSection",
    "venueType",
    "venueField",
    "onlineField",
    "capacityType",
    "capacityField",
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    this.reservationSectionTargets.forEach((section) => this.show(section, this.reservationRequired))
    this.venueFieldTargets.forEach((row) => this.show(row, this.reservationRequired && this.venueRequired))
    this.onlineFieldTargets.forEach((row) => this.show(row, this.reservationRequired && this.onlineRequired))
    this.capacityFieldTargets.forEach((row) => this.show(row, this.reservationRequired && this.capacityRequired))
  }

  show(element, visible) {
    element.hidden = !visible
    element.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }

  get reservationRequired() {
    return this.reservationRequiredTargets.some((radio) => radio.checked && radio.value === "1")
  }

  // NOTE: 開催形式ごとに使う項目は Event#uses_venue_information? / #uses_online_url? と揃えること。
  get venueRequired() {
    return this.venueType === "offline" || this.venueType === "hybrid"
  }

  get onlineRequired() {
    return this.venueType === "online" || this.venueType === "hybrid"
  }

  get capacityRequired() {
    return this.checkedValue(this.capacityTypeTargets) === "first_come"
  }

  get venueType() {
    return this.checkedValue(this.venueTypeTargets)
  }

  checkedValue(radios) {
    return radios.find((radio) => radio.checked)?.value
  }
}
